import React, { useState } from 'react';
import {
  FilterBarContainer,
  FiltersWrapper,
  FrequencyFilterWrapper,
  AccordionHeader,
  AccordionContent,
  AccordionToggle,
  FilterDropdownStyles,
} from './style';
import FilterBarV2 from '../../../components/FilterBar/FilterBarV2';
import FrequencyFilter from '../../../components/FilterBar/component/FrequencyFilter';
import { useFilterLogicV2 } from '../../../hooks/useFilterLogicV2';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { FaFilter } from 'react-icons/fa';

/**
 * LayoutV2 FilterBar - Uses the migrated FilterBarV2 component
 * This integrates the legacy filter logic with new PsdFilter components
 * Layout: Left-aligned filter dropdowns | Right-aligned frequency filter
 * Mobile/Tablet: Accordion with collapsible filters
 */
const FilterBar: React.FC = () => {
  const { goLiveMonth, goLiveYear } = useFilterLogicV2();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleAccordion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <FilterDropdownStyles />
      <FilterBarContainer>
        <AccordionHeader onClick={toggleAccordion}>
          <FaFilter />
          <AccordionToggle isExpanded={isExpanded}>
            {isExpanded ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </AccordionToggle>
        </AccordionHeader>
        <AccordionContent isExpanded={isExpanded}>
          <FiltersWrapper>
            <FilterBarV2 />
          </FiltersWrapper>
          <FrequencyFilterWrapper>
            <FrequencyFilter
              goLiveMonth={goLiveMonth}
              goLiveYear={goLiveYear}
            />
          </FrequencyFilterWrapper>
        </AccordionContent>
      </FilterBarContainer>
    </>
  );
};

export default FilterBar;
